function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "componentName",
    value: function componentName(jsonName) {
      var name = "".concat(jsonName.replace("/", "-").replace(/-v1$/, ""));

      if (!name.includes("-")) {
        // Avoid conflicting with builtin html elements
        return "views-" + name;
      }

      return name;
    }
  }, {
    key: "vueName",
    value: function vueName(component) {
      return component.$options._componentTag;
    }
  }]);

  return _default;
}();

export { _default as default };